import { useEffect, useState } from 'react';
import { SelectType } from '@features/contacts';
import { isPhoneNumber } from '@shared/helpers';
import type { ContactItem } from '@shared/types/contacts';
import { Card } from '@shared/ui';
import { BASE_URL_MAP, type ContactType, MAP_PLACEHOLDERS, VALIDATION_PATTERNS } from './constans.tsx';
import * as st from './style.module.scss';

export const ContactEdit: React.FC = () => {
  const [contactOption, setContactOption] = useState<ContactType>('phone');
  const [contactValue, setContactValue] = useState('');
  const [description, setDescription] = useState('');
  const [isValid, setValid] = useState(true);
  const [contact, setContact] = useState<Partial<ContactItem>>({
    id: 0,
    user: 0,
    type: contactOption,
    base_url: BASE_URL_MAP[contactOption],
    value: '',
    description: '',
  });

  const isNumberOption =
    contactOption === 'phone' || contactOption === 'viber' || contactOption === 'whatsapp';

  useEffect(() => {
    const localEditContact = localStorage.getItem('editContact');

    if (localEditContact) {
      const contactValue: ContactItem = JSON.parse(localEditContact);
      setContactOption(contactValue.type);
      setContactValue(contactValue.value);
      setDescription(contactValue.description);
      setContact(contactValue);
    }
  }, []);

  useEffect(() => {
    const localUserId = localStorage.getItem('userId');
    if (localUserId) {
      setContact((prev) => ({ ...prev, user: Number(localUserId) }));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('contactValue', JSON.stringify(contact));
  }, [contact]);

  const handleChangeType = (type: ContactType) => {
    setContactOption(type);
    setContact((prev) => ({ ...prev, type, base_url: BASE_URL_MAP[type] }));
  };

  const handleChangeContactValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    validationValue(value);
    setContactValue(value);
    setContact((prev) => ({
      ...prev,
      value,
    }));
  };

  const handleChangeDescription = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setDescription(value);
    setContact((prev) => ({ ...prev, description: value }));
  };

  const validationValue = (value: string) => {
    const pattern = VALIDATION_PATTERNS[contactOption];
    if (isNumberOption && value.length > 11) {
      setValid(false);
    } else if (!pattern.test(value)) {
      setValid(false);
    } else {
      setValid(true);
    }
  };

  return (
    <Card>
      <div className={st.wrapper}>
        <SelectType
          wrapperClassName={st.mobileFullWidth}
          contactOption={contactOption}
          setContactOption={handleChangeType}
        />
        <div className={`${st.fieldset} ${st.mobileFullWidth} ${!isValid && st.error}`}>
          <span className={st.nameList}>URL/телефон</span>
          <input
            placeholder={MAP_PLACEHOLDERS[contactOption]}
            type={isNumberOption ? 'number' : 'text'}
            value={
              isPhoneNumber(contactValue)
                ? contactValue.replace(/ /g, '').replace(/-/g, '')
                : contactValue
            }
            onChange={handleChangeContactValue}
          />
        </div>
      </div>
    </Card>
  );
};
